var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('portal',{attrs:{"to":"modal-portal"}},[_c('div',{class:_vm.modalClass},[_c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container"},[_vm._t("default")],2)])])])])}
var staticRenderFns = []

export { render, staticRenderFns }